module.exports = __webpack_public_path__ + "img/avatar3.8785515c.jpg";